import React from "react";
import BasicModal from "../_widgets/Modal/BasicModal";
import { Col, Row } from "react-bootstrap";
import Input from "../_widgets/Input/Input";
import { warn } from "../../Wrapper/toast/toast";
import { MAX_50_CHARS } from "../../Constants/stringConstants";

const AddCommentModal = ({
  modalShow,
  setModalShow,
  handleClose,
  addInventoryData,
  addInventory,
  buttonLoading,
  setAddInventoryData,
}) => {
  return (
    <BasicModal
      show={modalShow}
      size="md"
      setModalShow={setModalShow}
      handleClose={handleClose}
      heading={`Add Comment for ${addInventoryData?.name}`}
      footer
      button2Text="Save"
      button2Click={() => addInventory()}
      loading={buttonLoading}
    >
      <div className="patients_ui">
        <Row>
          <Col xl={12}>
            <div className="white_card text-start">
              <Row className="mb-3">
                <Col lg={12}>
                  <Input
                    isRequired={true}
                    placeholder="Comment"
                    type="text"
                    label="Comment"
                    value={addInventoryData.comment}
                    onChange={(e) => {
                      if (e.target.value.length <= 50) {
                        setAddInventoryData({
                          ...addInventoryData,
                          comment: e.target.value,
                        });
                      } else {
                        warn(MAX_50_CHARS);
                      }
                    }}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </BasicModal>
  );
};

export default AddCommentModal;
